import * as React from "react";

const IconFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      d="M11 9.259h-.926c-.278-.593-.87-1-1.574-1-.704 0-1.296.407-1.574 1H1a.763.763 0 0 0-.76.759c0 .407.334.76.76.76h5.926c.278.592.87 1 1.574 1 .704 0 1.296-.408 1.574-1H11c.407 0 .76-.334.76-.76a.75.75 0 0 0-.76-.76Zm-2.5 1.5a.763.763 0 0 1-.76-.76c0-.407.334-.759.76-.759s.76.334.76.76c0 .425-.334.759-.76.759Zm2.5-5.5H5.074c-.278-.593-.87-1-1.574-1-.704 0-1.296.407-1.574 1H1a.763.763 0 0 0-.76.759c0 .407.334.76.76.76h.926c.278.592.87 1 1.574 1 .704 0 1.296-.408 1.574-1H11c.407 0 .76-.334.76-.76a.75.75 0 0 0-.76-.76Zm-7.5 1.5a.763.763 0 0 1-.76-.76c0-.425.334-.759.76-.759s.76.334.76.76c0 .425-.334.759-.76.759Zm7.5-5.5H8.574c-.278-.593-.87-1-1.574-1-.704 0-1.296.407-1.574 1H1a.763.763 0 0 0-.76.76c0 .406.334.758.76.758h4.426c.278.593.87 1 1.574 1 .704 0 1.296-.407 1.574-1H11c.407 0 .76-.333.76-.759a.75.75 0 0 0-.76-.76Zm-4 1.5a.763.763 0 0 1-.76-.76c0-.407.334-.759.76-.759.407 0 .76.334.76.76 0 .425-.334.759-.76.759Z"
      fill="#4F4FFF"
    />
  </svg>
);

export default IconFilter;
